export type AppointmentState =
  | "pending"
  | "agreed"
  | "disagreed"
  | "cancelled"
  | "other";

export class Appointment {
  id?: number;
  start_at: Date;
  end_at?: Date;
  place: string;
  state?: AppointmentState;
  send_user_id?: number;
  chat_room_id?: number;

  constructor(fields: any) {
    for (const f in fields) {
      this[f] = fields[f];
    }
  }

  getStartAt(): Date {
    return new Date(this.start_at);
  }

  getEndAt(): Date {
    return new Date(this.end_at);
  }

  getStartAtDateString(): string {
    return (
      this.getStartAt().getFullYear() +
      "年" +
      (this.getStartAt().getMonth() + 1) +
      "月" +
      this.getStartAt().getDate() +
      "日"
    );
  }

  getTimeString(): string {
    let startAtTime: string =
      this.getStartAt().getHours() +
      ":" +
      ("00" + this.getStartAt().getMinutes()).slice(-2);
    let endAtTime: string = this.end_at
      ? this.getEndAt().getHours() +
        ":" +
        ("00" + this.getEndAt().getMinutes()).slice(-2)
      : "";
    return startAtTime + "〜" + endAtTime;
  }

  getStateString(): string {
    switch (this.state) {
      case "pending":
        return "確認待ち";
      case "agreed":
        return "成立";
      default:
        return "";
    }
  }

  isPending(): boolean {
    return this.state === "pending";
  }

  isWithinWeek(): boolean {
    return (
      (this.getStartAt().getTime() - new Date().getTime()) /
        1000 /
        60 /
        60 /
        24 <=
      7
    );
  }

  isSendUser(id: number): boolean {
    return this.send_user_id === id;
  }

  isTomorrow(): boolean {
    let tomorrow: Date = new Date();
    tomorrow = new Date(tomorrow.setDate(tomorrow.getDate() + 1));
    return (
      this.getStartAt().getFullYear() === tomorrow.getFullYear() &&
      this.getStartAt().getMonth() === tomorrow.getMonth() &&
      this.getStartAt().getDate() === tomorrow.getDate()
    );
  }
}



// WEBPACK FOOTER //
// ./src/models/appointment.ts